<div class="container-fluid justify-content-center section mt-3 mb-3 pb-3 pt-2">
  <div class="d-flex flex-column">
    <div class="review-title mt-3 mb-3">What people says about me</div>
    <div *ngIf="testimonials1.length" class="pc">
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" data-interval="false">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators" [attr.data-slide-to]="a"
            *ngFor="let slide of testimonials1; let a = index" [ngClass]="{active: a == 0}"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item" *ngFor="let list1 of testimonials1; let i= index" [ngClass]="{active: i == 0}">
            <div class="row justify-content-center">
              <div class="col-6 pr-2">
                <div class="review-box px-3" *ngIf="testimonials1[i] != undefined">
                  <div class="d-flex flex-column text-quote mt-3">“</div>
                  <div class="review-content">{{testimonials1[i].testimonial}}</div>
                  <div class="py-2 px-3 d-flex flex-column">
                    <div class="divider"></div>
                    <img *ngIf="testimonials1[i].testifyingMum[0].profileImage"
                      [src]="testimonials1[i].testifyingMum[0].profileImage" alt="" class="profile-img">
                    <img *ngIf="!testimonials1[i].testifyingMum[0].profileImage"
                      src="../../../../assets/Images/pro-pic.png" alt="" class="profile-img">
                    <span class="profile-name mt-2">{{testimonials1[i].testifyingMum[0].name}}</span>
                  </div>
                </div>
              </div>
              <div class="col-6 pl-2">
                <div class="review-box px-3" *ngIf="testimonials2[i] != undefined">
                  <div class="d-flex flex-column text-quote mt-3">“</div>
                  <div class="review-content">{{testimonials2[i].testimonial}}</div>
                  <div class="py-2 px-3 d-flex flex-column">
                    <div class="divider"></div>
                    <img *ngIf="testimonials2[i].testifyingMum[0].profileImage"
                      [src]="testimonials2[i].testifyingMum[0].profileImage" alt="" class="profile-img">
                    <img *ngIf="!testimonials2[i].testifyingMum[0].profileImage"
                      src="../../../../assets/Images/pro-pic.png" alt="" class="profile-img">
                    <span class="profile-name mt-2">{{testimonials2[i].testifyingMum[0].name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row ml-6" style="display: flex; justify-content: flex-end;">
        <div class="navigation-arrow mr-3" data-target="#carouselExampleIndicators" data-slide="prev">
          <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
        </div>
        <div class="navigation-arrow" data-target="#carouselExampleIndicators" data-slide="next">
          <i class="fas fa-long-arrow-alt-right arrow-icon"></i>
        </div>
      </div>
    </div>
    <div *ngIf="testimonials.length" class="mobile">
      <div id="carouselExampleIndicators2" class="carousel slide" data-ride="carousel" data-interval="false">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicators2" [attr.data-slide-to]="a"
            *ngFor="let slide of testimonials; let a = index" [ngClass]="{active: a == 0}"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item" *ngFor="let list1 of testimonials; let i= index" [ngClass]="{active: i == 0}">
            <div class="row justify-content-center">
              <div class="col-12">
                <div class="review-box px-3" *ngIf="testimonials[i] != undefined">
                  <div class="d-flex flex-column text-quote mt-3">“</div>
                  <div class="review-content">{{testimonials[i].testimonial}}</div>
                  <div class="py-2 px-3 d-flex flex-column">
                    <div class="divider"></div>
                    <img *ngIf="testimonials[i].testifyingMum[0].profileImage"
                      [src]="testimonials[i].testifyingMum[0].profileImage" alt="" class="profile-img">
                    <img *ngIf="!testimonials[i].testifyingMum[0].profileImage"
                      src="../../../../assets/Images/pro-pic.png" alt="" class="profile-img">
                    <span class="profile-name mt-2">{{testimonials[i].testifyingMum[0].name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row ml-6" style="display: flex; justify-content: flex-end;">
        <div class="navigation-arrow mr-3" data-target="#carouselExampleIndicators2" data-slide="prev">
          <i class="fas fa-long-arrow-alt-left arrow-icon"></i>
        </div>
        <div class="navigation-arrow" data-target="#carouselExampleIndicators2" data-slide="next">
          <i class="fas fa-long-arrow-alt-right arrow-icon"></i>
        </div>
      </div>
    </div>
    <div class="no-data" *ngIf="!testimonials1.length">
      <img class="align-self-center" src="../../../../../assets/Images/NoDocuments.png" height="50" width="80"
        alt="No People Reviews">
      <span>No People Reviews</span>
    </div>
  </div>
</div>